import { render } from "./IndexList.vue?vue&type=template&id=df381c14&scoped=true"
import script from "./IndexList.vue?vue&type=script&lang=js"
export * from "./IndexList.vue?vue&type=script&lang=js"

import "./IndexList.vue?vue&type=style&index=0&id=df381c14&scoped=true&lang=scss"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df381c14"]])

export default __exports__